import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

interface ApolloClientRef {
    accessToken: string | null;
    currentInstance: ApolloClient<NormalizedCacheObject> | null;
}

export const apolloClientRef: ApolloClientRef = {
    accessToken: '',
    currentInstance: null,
};
